import styled from 'styled-components'
import React from 'react'
import {
  CreativesBlockBottom,
  CreativesBlockContent,
  CreativesBlockTop,
  CreativesButton,
} from '@/components/Creatives/CreativesStyled'
import Input from '@/components/ui/Input'
import ButtonIcon from '@/components/common/ButtonIcon'
import Icon from '@/components/common/Icon'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'

const FavoritesCreateContent = styled(CreativesBlockContent)`
  padding: 24px;
`

const CreativesInput = styled.div`
  position: relative;
  width: 100%;

  .search {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 24px;
  }

  .search-input input {
    height: 52px;
    padding: 14px 24px;
    padding-right: 48px;
  }
`

const ButtonClose = styled(ButtonIcon)`
  width: 30px;
  height: 30px;
  cursor: pointer;
  background-color: var(--tertiary);
  transition: transform 0.26s ease-in-out;
  flex-shrink: 0;
`

const FavoritesCreateContentWrap = styled(FavoritesCreateContent)`
  padding: 12px;

  &.default {
    padding: 0;
  }
`

const CreativesBlockTopWrap = styled(CreativesBlockTop)`
  border-bottom: 1px solid #e0e1e2;
  padding: 10px 16px 8px;
`

const ButtonsDropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const ButtonsDropdownWrap = styled.div`
  padding: 8px 12px 0;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e0e1e2;
`

const DropdownButton = styled.button`
  color: var(--purple);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.21px;
  background-color: transparent;
  padding: 12px 8px;
`

const CreativesSelectMultiplyMobile = ({
  selectAll,
  reset,
  children,
  isNoPadding,
  onClose,
  inputValue,
  onChange,
}) => {
  const t = useTranslations('creatives')
  const clearInput = () => {
    console.log('clearInput')
  }
  const selectAllCheckboxes = () => {
    selectAll()
  }
  const resetAll = () => {
    reset()
  }

  const wrapClasses = classNames({
    default: isNoPadding,
  })

  return (
    <>
      <CreativesBlockTopWrap>
        <ButtonClose onClick={onClose} type="button" icon="chevron-left" />
        <CreativesInput>
          <Input
            value={inputValue}
            onChange={(e) => onChange(e.target.value)}
            theme="grey"
            className="search-input"
            placeholder="Введите значение"
          />
          <Icon
            className="search"
            size={18}
            color="divider"
            icon="creatives-close"
            onClick={clearInput}
          />
        </CreativesInput>
      </CreativesBlockTopWrap>
      <ButtonsDropdownWrap>
        <ButtonsDropdownWrapper>
          <DropdownButton onClick={selectAllCheckboxes}>
            {t('selectAll')}
          </DropdownButton>
          <DropdownButton onClick={resetAll}> {t('reset')}</DropdownButton>
        </ButtonsDropdownWrapper>
        <Divider />
      </ButtonsDropdownWrap>
      <FavoritesCreateContentWrap className={wrapClasses}>
        {children}
      </FavoritesCreateContentWrap>
      <CreativesBlockBottom>
        <CreativesButton block filled>
          {t('apply')}
        </CreativesButton>
      </CreativesBlockBottom>
    </>
  )
}

export default CreativesSelectMultiplyMobile
